import _ from 'underscore'
import stickybits from 'stickybits'

const THROTTLE_WAIT = 500

export default function(el) {
  const stickyBits = stickybits(el, {
    noStyles: true,
    useStickyClasses: true,
    stickyClass: 'wz-sticky-bar--stuck'
  })

  // FIXME: Remove after resolve https://github.com/dollarshaveclub/stickybits/issues/100
  const instance = stickyBits.instances[0]

  function calcStickySettings() {
    const { top, bottom } = instance.parent.getBoundingClientRect()
    instance.stickyStart = top + window.scrollY
    instance.stickyStop = bottom + window.scrollY
    stickyBits.manageState(instance)
  }

  let lastScrollHeight = 0
  function checkScrollHeight() {
    const scrollHeight = instance.parent.scrollHeight
    if (lastScrollHeight !== scrollHeight) {
      lastScrollHeight = scrollHeight
      calcStickySettings()
    }
  }

  window.addEventListener('scroll', _.throttle(checkScrollHeight, THROTTLE_WAIT))
  checkScrollHeight()

  return stickyBits
}
